<div class="table-fms">
  <table>
    <thead>
    <tr>
      <th class="fix-w-19p75"></th>
      <th class="fix-w-0p25 blank-space"></th>
      @for (header of [].constructor(12); track $index; let i = $index) {
        <th
          class="fix-w-5p5"
          [class.blank-space]="[5, 10].includes(i)">
          {{header}}
        </th>
      }
    </tr>
    </thead>
    <tbody>
      @for (i of [].constructor(25); track $index) {
        <tr
          class="animation-wrapper"
          app-table-empty-state
          [tdAmount]="14"
          [blankSpaceIndices]="[1, 7, 12]">
        </tr>
      }
    </tbody>
  </table>
</div>
